/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */


import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sysque-dropdown-options-line',
  templateUrl: './sysque-dropdown-options-line.component.html',
  styleUrls: ['./sysque-dropdown-options-line.component.scss'],
  standalone: false
})
export class SysqueDropdownOptionsLineComponent {
  @Input() label: string;
  @Input() data: string[];
  @Input() disabled: boolean;
  @Input() showClearButton: boolean;
  @Input() placeholder: string;
  @Input() width: string;
  @Input() height: string;
  @Input() selectedValue: string;
  @Output() valueChanged: EventEmitter<string> = new EventEmitter<string>();
  
  public onValueChanged($event: string): void {
    this.valueChanged.emit($event);
  }

}
